<div class="header-kpi-container">
  <div class="header-kpi-filter">
    <app-filter-button
      [type]="'checkbox'"
      [label]="'containerType'"
      [icon]="'container'"
      [checkedData]="filterContainers"
      (manageList)="manageContainers($event)"
    ></app-filter-button>
    <app-filter-button
      [type]="'checkbox'"
      [label]="'containerCategory'"
      [icon]="'pallet'"
      [checkedData]="filterContainerCategory"
      (manageList)="manageContainerCategory($event)"
    ></app-filter-button>
    <app-filter-button
      [type]="'checkbox'"
      [label]="'devicesTypes'"
      [icon]="'devices-types'"
      [checkedData]="filterDevicesTypes"
      (manageList)="manageDevicesTypes($event)"
    ></app-filter-button>
    <app-filter-button
      [type]="'radio'"
      [label]="'torn'"
      [icon]="'torn'"
      [radioData]="tornFilterOptions"
      [defaultRadioValue]="filterTorn"
      (manageList)="manageTorn($event)"
      [isEmpty]="!tornFilterOptions.length"
      [pathTranslate]="'filter.torn.label.{{item}}'"
    ></app-filter-button>
    <app-filter-button
      [type]="'radio'"
      [label]="'unknown'"
      [icon]="'unknown'"
      [radioData]="unknownFilterOptions"
      [defaultRadioValue]="filterUnknown"
      (manageList)="manageUnknown($event)"
      [isEmpty]="!unknownFilterOptions.length"
      [pathTranslate]="'filter.unknown.label.{{item}}'"
    ></app-filter-button>
  </div>
</div>
